import { BehaviorSubject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToastService, Validators } from '@peca/commons';
import { DesignSystemModule } from '@peca/design-system';

import { IAsyncState } from '../../../../../core/interfaces/async-state.interface';
import { SearchService } from '../../../services/search.service';
import { CredentialsPipe } from '../../../pipes/credentials.pipe';
import { SalesChannelService } from 'apps/dialect/src/app/core/services/sales-channel-autorization.service';

@Component({
  selector: 'peca-search-authorization',
  templateUrl: './search-authorization.component.html',
  styleUrl: './search-authorization.component.scss',
  imports: [CommonModule, DesignSystemModule, ReactiveFormsModule, CredentialsPipe],
})
export class SearchAuthorizationComponent implements OnInit {
  searchService = inject(SearchService);
  toastService = inject(ToastService);
  salesChannelService = inject(SalesChannelService);
  authorization$ = new BehaviorSubject<IAsyncState<string | null>>({});

  form = new FormGroup({
    clientId: new FormControl('', [Validators.required]),
    clientSecret: new FormControl('', [Validators.required]),
  });

  ngOnInit() {
    this.salesChannelService.credentials$.subscribe((token) => this.authorization$.next({ data: token! }));

    this.authorization$.subscribe((token) => {
      if (!token.data) {
        this.form.enable();
        this.form.setValue({ clientId: '', clientSecret: '' });
      } else {
        this.form.disable();
      }
    });
  }

  onClickAuthorize() {
    if (this.form.invalid) return;

    const { clientId, clientSecret } = this.form.getRawValue() as { clientId: string; clientSecret: string };

    this.form.disable();

    this.salesChannelService.authorize(clientId, clientSecret).subscribe({
      error: () => {
        this.toastService.failure(`Falha ao autorizar o canal de venda ${clientId}`);
        this.authorization$.next({ failure: true });
        this.form.enable();
      },
    });
  }

  onClickClear() {
    this.salesChannelService.logout();
  }
}
